import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 0 20px;
  max-width: 400px;
`

export const SaveCard = styled.div`
  display: flex;
  align-items: center;
  padding: 0 0 15px;

  input {
    margin-right: 10px;
  }
`
